import {Device} from "../../model/device";

export class ResetPasswordRequest extends Device {
  newPassword: string;

  password: string;
  confirmPassword: string;

  constructor() {
    super();
  }
}


// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/auth/reset-password/reset-password-request.ts